// extracted by mini-css-extract-plugin
export default {"profileDesktop":"Profile_profileDesktop__mtPyu"};